module.exports = __webpack_public_path__ + "img/favorites.e1b9e3b4.svg";